import React from 'react'
import propTypes from 'prop-types'
import Card from '@mui/material/Card'
import { IoIosAddCircleOutline } from "react-icons/io";

const Product = ({ productsList }) => {
    console.log(productsList)
  return (
    <div className='product-display'>
      {productsList.map((item, index) => (
            <Card className='product-cards'>
              <div className='image-block'>
                <span className='add-to-cart-icon'><IoIosAddCircleOutline /></span>
              </div>
              <div className='product-details'>
                <span key={index}>{item.productName}</span>
                <span key={index}>{item.price}</span>
              </div>
            </Card>
      ))}
    </div>
  )
}

Product.propTypes = {
    productsList: propTypes.array.isRequired
}
  
export default Product